import React from 'react';
import './ShowExpanded.less';

const ShowExpanded = ({ expanded }) => {
  if (expanded) {
    return <i className="glyphicon glyphicon-triangle-bottom show-expanded" />;
  } else {
    return <i className="glyphicon glyphicon-triangle-right show-expanded" />;
  }
};

export default ShowExpanded;



// WEBPACK FOOTER //
// ./src/shared/ShowExpanded.js